// Components==============
import Avatar from 'components/UI/Avatar/Avatar';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import React from 'react';
import './MemberBar.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
// =========================

type Props = {
  user?: UserEntity;
  name?: React.ReactNode;
  question?: string;
};

export default function MemberBar({ user, question, name }: Props) {
  return (
    <div styleName="wrapper">
      <Tooltip
        position="top"
        content={
          <p>
            {user?.first_name} {user?.last_name}
          </p>
        }
        key={user?.id}
      >
        <Avatar border user={user} />
      </Tooltip>
      {question && (
        <div styleName="question">
          {' '}
          <h3>{question}</h3>{' '}
        </div>
      )}
      {name && name}
      {name && (
        <Tooltip
          position="top"
          content={
            <div styleName="feedback-extern-tooltip">
              <Avatar size="big" user={user} />
              <h2>
                {user?.first_name} {user?.last_name}
              </h2>
              <a href={`mailto:${user?.email}`}>{user?.email}</a>
              {user?.company?.length && (
                <p styleName="company">{user?.company}</p>
              )}
              {user?.phonenumber?.length && <p>{user?.phonenumber}</p>}
              {user?.website?.length && (
                <a
                  href={
                    user?.website
                      ? user.website.startsWith('http')
                        ? user.website
                        : `http://${user.website}`
                      : ''
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  {user?.website}
                </a>
              )}
            </div>
          }
          key={name?.toString()}
        >
          <div styleName="info">
            <FontAwesomeIcon icon={faInfoCircle} color="grey" opacity={0.3} />
          </div>
        </Tooltip>
      )}
    </div>
  );
}
